const ABSOLUTE_URL_RE = /^[a-z]+:\/\//i;

function normalizePublicUrl(raw: string | undefined): string {
  if (!raw || raw === '.') {
    return '';
  }

  return raw.replace(/\/+$/, '');
}

function normalizeAssetPath(assetPath: string): string {
  return assetPath.replace(/^\/+/, '');
}

export function resolvePublicAssetPath(assetPath: string): string {
  if (!assetPath) {
    return '';
  }

  if (ABSOLUTE_URL_RE.test(assetPath)) {
    return assetPath;
  }

  const normalizedPath = normalizeAssetPath(assetPath);
  const publicUrl = normalizePublicUrl(process.env.PUBLIC_URL);

  if (!normalizedPath) {
    return publicUrl || '/';
  }

  return publicUrl ? `${publicUrl}/${normalizedPath}` : `/${normalizedPath}`;
}

export function resolveVendorManifestPath(tenantId: string): string {
  return resolvePublicAssetPath(`vendors/${tenantId}.json`);
}
